
import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { CollectionService } from "./ApplicationServices/CollectionService";
import { ItemModifierService } from "./ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "./shared/store/userInfo.store";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {
  title = "website";
  collapse: boolean = true;
  loggedIn: boolean = false;
  username = "";
  totalCartItems = 0;
  totalCartValue = 0;
  cartItems: any;

  searchKey: string = '';
  itemData: any;
  options: any[] = [];
  filteredOptions1: any[];

  constructor(private infoStore: UserInfoStore,
    private router: Router,
    private itemModifierService: ItemModifierService,
    private collectionService: CollectionService) { }


  ngOnInit() {

    ///this.username = state.info.UserFullName;

    this.infoStore.state$.subscribe((state) => {

     /// this.username = state.info.UserFullName;

      if (state && state.info && state.info.OrderMaster_Id) {
        this.loggedIn = true;
        this.username = state.info.UserFullName;
      } 
      else if 
      (
        sessionStorage.getItem("OrderMaster_Id") &&
        sessionStorage.getItem("UID") &&
        sessionStorage.getItem("Name")
      ) 
      {
        this.infoStore.setInfo({
          UserId: sessionStorage.getItem("UID"),
          UserFullName: sessionStorage.getItem("Name"),
          OrderMaster_Id: sessionStorage.getItem("OrderMaster_Id"),
        });
      } else {
        this.loggedIn = false;
        this.username = "";
      }

      if (state && state.cartInfo && state.cartInfo.length > 0) {
        console.log(state.cartInfo);
        this.totalCartItems = 0;
        this.totalCartValue = 0;

        state.cartInfo.forEach((element) => {
          this.totalCartItems = element.Qty + this.totalCartItems;
          this.totalCartValue =
            (element.Qty * element.Price) + this.totalCartValue;
        });
        this.cartItems = state.cartInfo;

      } else {
        this.totalCartItems = 0;
        this.cartItems = [];
        this.totalCartValue = 0;
      }
    });

    //sessionStorage.setItem("RazorAmount", "0.00");
    // sessionStorage.setItem("RazorAmount", this.totalCartValue.toString());
    this.getCartInfo();
    this.getFillSKUWithoutID();
  }

  navigate(path) {
    this.router.navigateByUrl(path);
  }

  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }

  logout() {
    this.loggedIn = false;
    sessionStorage.clear();
    this.infoStore.setInfo({});
    ///this.router.navigateByUrl("home");
    this.router.navigateByUrl("login");
    this.totalCartItems = 0;
    this.cartItems = [];
    this.totalCartValue = 0;
  }

  routeSingle(itemId, sku) {
    this.router.navigateByUrl("/single-product/" + itemId + "&" + sku);
  }

  getFillSKUWithoutID() {
    this.collectionService.getAllItemBasic2VariationByItemProductTypeMainId(0)
      .subscribe((data: any) => {
        this.itemData = data.filter((test, index, array) => {
          return index === array.findIndex((findTest) =>
            findTest.SearchKeywordsWords === test.SearchKeywordsWords
          )
        });
        this.options = this.itemData.filter((option) => {
          return option.SearchKeywordsWords != null
        })
      });
  }

  onSeachDropdownValue($event) {
    const value = $event.target.value;
    this.filteredOptions1 = this.filter1(value);
  }

  filter1(name: string) {
    const filterValue = name.toLowerCase();
    if (filterValue != '') {
      return this.options.filter(
        (option) => option.SearchKeywordsWords.toLowerCase().indexOf(filterValue) === 0
      );
    }
  }

  onSelectDropdownValue(option) {
    this.searchKey = option.SearchKeywordsWords;
    this.filteredOptions1 = [];
    this.router.navigate(['./search-bar'], { queryParams: { searchKey: this.searchKey } });
  }

  onSearchKeywordValue(searchKeyword) {
    this.searchKey = searchKeyword;
    this.filteredOptions1 = [];
    this.router.navigate(['./search-bar'], { queryParams: { searchKey: this.searchKey } });
  }

}


